import { createSelector } from "reselect";

const LOAD_WORK_ORDER_DETAILS = "LOAD_WORK_ORDER_DETAILS";
const CLEAR_WORK_ORDERS = "CLEAR_WORK_ORDERS";

const initialState = {
  wax: {},
  assembly: {},
  dip: {},
  autoclave: {},
  foundry: {},
  post: {},
  routes: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "FLUSH":
    case CLEAR_WORK_ORDERS: {
      return initialState;
    }

    case LOAD_WORK_ORDER_DETAILS: {
      const newState = {
        ...state,
        wax: action?.data?.part?.wax,
        assembly: action?.data?.part?.assembly,
        dip: action?.data?.part?.dip,
        autoclave: action?.data?.part?.autoclave,
        foundry: action?.data?.part?.foundry,
        post: action?.data?.part?.post,
        routes: action?.data?.routes || [],
      };
      return newState;
    }

    default:
      return state;
  }
}

export function setWorkOrderDetails(data = {}) {
  return {
    type: LOAD_WORK_ORDER_DETAILS,
    data,
  };
}

export const getWorkOrderState = createSelector(
  (state) => state,
  (state) => state?.workOrder
);

export const getWorkOrderWaxInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.wax || {}
);

export const getWorkOrderAssemblyInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.assembly || {}
);

export const getWorkOrderDipInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.dip || {}
);

export const getWorkOrderAutoclaveInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.autoclave || {}
);

export const getWorkOrderFoundryInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.foundry || {}
);

export const getWorkOrderFinishingInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.post || {}
);

export const getWorkOrderInstructions = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.part?.instructions || []
);

export const getWorkOrderRoutings = createSelector(
  getWorkOrderState,
  (workOrder) => workOrder?.routes || []
);
